export default "__VITE_ASSET__CwZpWPy5__"